// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('@rails/ujs').start()
require('turbolinks').start()
require('@rails/activestorage').start()
require('channels')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import './overlay'
import './servicemenu'
import './advertisementpwa'
import './postdetail'
import './needs'

// vue loader
import Vue from 'vue'

Vue.directive('init', {
	bind: function(el, binding, vnode) {
		vnode.context[binding.arg] = binding.value
	},
})

// グローバルな状態管理
const vueState = {
	instances: new Map(),
	options: {},
}

const requireContext = require.context('./options', false, /\.js$/)
requireContext.keys().forEach((key) => {
	const name = key
		.split('/')
		.pop()
		.split('.')
		.shift()
	vueState.options[name] = requireContext(key).default
})

const initVueComponents = () => {
	console.log('Initializing Vue components...')

	// 既存のインスタンスをクリーンアップ
	vueState.instances.forEach((vm) => {
		try {
			vm.$destroy()
			console.log('Successfully destroyed Vue instance')
		} catch (e) {
			console.error('Error destroying Vue instance:', e)
		}
	})
	vueState.instances.clear()

	// 新しいインスタンスを作成
	document.querySelectorAll('[data-vue]').forEach((el) => {
		const componentName = el.dataset.vue
		if (vueState.options[componentName]) {
			try {
				const vm = new Vue(Object.assign({}, vueState.options[componentName], { el }))
				vueState.instances.set(el, vm)
				console.log(`Created Vue instance for component: ${componentName}`)
			} catch (e) {
				console.error(`Error creating Vue instance for ${componentName}:`, e)
			}
		} else {
			console.warn(`No options found for component: ${componentName}`)
		}
	})
}

document.addEventListener('turbolinks:load', () => {
	console.log('turbolinks:load - initializing Vue components')
	initVueComponents()

	// ツールチップの初期化
	$('[data-toggle="tooltip"]').tooltip()
})

// ページ遷移前のクリーンアップ
document.addEventListener('turbolinks:before-cache', () => {
	console.log('turbolinks:before-cache - cleaning up Vue instances')
	vueState.instances.forEach((vm) => {
		try {
			vm.$destroy()
			console.log('Successfully destroyed Vue instance during cache cleanup')
		} catch (e) {
			console.error('Error destroying Vue instance during cache cleanup:', e)
		}
	})
	vueState.instances.clear()
})

// ページ読み込み時の固定ボディ処理
document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.js-bodyfixed')) {
		const scrollY = window.scrollY || window.pageYOffset
		$('.js-bodyfixed').css({
			position: 'fixed',
			top: `-${scrollY}px`,
		})
	}
})

$(() => {
	$('[data-toggle="tooltip"]').tooltip()
})
